import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Finance BPA</h1>
          <p className="text-primary-100 text-lg">Finance BPA</p>
        </div>

        {/* Auth form card */}
        <div className="card">
          <Outlet />
        </div>

        {/* Footer */}
        <div className="text-center mt-6 text-primary-100 text-sm">
          <p>&copy; 2025 Finance BPA. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
